export default __webpack_public_path__ + "static/media/mobileiphone-preview.9a99424d.svg";